// extracted by mini-css-extract-plugin
export default {"contacts":"Contacts_contacts__AkU-B","title":"Contacts_title__jgHaR"};